import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { Accordion } from "@components/accordion/Accordion";
import Button from "@components/button/Button";
import cn from "classnames";
import PageH1 from "@components/seo/PageH1";
const LocalLocationsList = ({ title, description, locations, listTitle }) => {
    const accordionItems = useCallback(() => {
        return locations.map(({ title: accordionTitle, items }, idx) => {
            const firstLetter = encodeURI(accordionTitle.charAt(0));
            return {
                title: accordionTitle,
                isOpen: false,
                id: `${firstLetter}${idx}`,
                content: (_jsx("ul", { children: items.map(({ title: locationTitle, url: locationUrl }) => (_jsx("li", { children: _jsx(Button, { title: locationTitle, link: locationUrl, type: "tertiary" }) }, locationTitle + locationUrl))) }))
            };
        });
    }, [locations]);
    return (_jsxs("section", { className: "local-locations container", children: [title && (_jsx(PageH1, { fallbackElement: "h2", className: "local-locations__title", children: title })), description && _jsx("p", { className: "local-locations__subtitle", dangerouslySetInnerHTML: { __html: description } }), _jsxs("section", { className: "local-locations__list", children: [listTitle && _jsx("h3", { className: "local-locations__list-heading", children: listTitle }), locations && locations.length !== 0 && (_jsx(Accordion, { className: cn("local-locations__list-accordions", locations.length === 1 && "local-locations__list--single"), accordionItems: accordionItems(), accordionClassName: "border-0 border-t-2 lg:border-b-2" }))] })] }));
};
export default LocalLocationsList;
